<template>
    <div class="header">
        <img src="../../assets/dzlogo.png" alt="">
        <span>帐号激活</span>
    </div>
</template>

<script>
    export default {
        name: "headers",
        data() {
            return {

            }
        }
    }
</script>

<style scoped>
.header{
    width: 100%;
    height: 64px;
    background: #fff;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
}
.header img{
    max-width: 63%;
    height: 44px;
    margin-left: 25px;
}
.header span{
        line-height: 64px;
        margin-left: 18px;
        font-weight: 700;
        font-size: 18px;
        letter-spacing: 2px;
    }
.header span:before {
    content: "|";
    position: relative;
    right: 8px;
    top: -2px;
}
</style>



// WEBPACK FOOTER //
// header.vue?a41a8248